import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Axios from "axios";
import April25Page from "./April25";
import May25Page from "./May25";
import June25Page from "./June25";
import July25Page from "./July25";
import August25Page from "./August25";
import September25Page from "./September25";
import October25Page from "./October25";
import NovDec25Page from "./NovDec25";
import SimpleTableDistance from "./SimpleTableDistance";
import SimpleTableStrength from "./SimpleTableStrength"; //Max Count Metirc, Pushups, Squats, etc.
//import SimpleTableStrengthPoints from "./SimpleTableStrengthPoints";
//import SimpleTableDspStrength from "./SimpleTableDspStrength";
import SimpleTableWallsit from "./SimpleTableWallsit";
//import SimpleTablePlank from "./SimpleTablePlank";
import SimpleTableTeams from "./SimpleTableTeams";
import TeamDistribution from "./TeamDistribution";
import RulesAndRegulations from "./RulesAndRegulations";
import { useNavigate } from "react-router-dom";

const January26 = () => {
  const [distanceData, setDistanceData] = useState([]);
  const [strengthData, setStrengthData] = useState([]);
  const [teamsData, setTeamsData] = useState([]);
  const [activeTab, setActiveTab] = useState("teams"); // New state for tab selection
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [distanceRes, strengthRes, teamsRes] = await Promise.all([
          Axios.get("/api/distancejanuary26/"),
          Axios.get("/api/strengthjanuary26/"),
          Axios.get("/api/teamsjanuary26/"),
        ]);
        console.log("Distance January ->", distanceRes.data);

        setDistanceData(distanceRes.data);
        setStrengthData(strengthRes.data);
        setTeamsData(teamsRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const styles = {
    container: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100vh",
      paddingTop: "10vh",
      backgroundColor: "#f3f4f6",
    },
    heading: { // 🔹 Add this block
      fontSize: "2rem",
      fontWeight: "bold",
      marginBottom: "20px",
      color: "#1f2937",
  },
    tabs: {
      display: "flex",
      justifyContent: "center",
      gap: "15px",
      marginBottom: "20px",
    },
    tabButton: (isActive) => ({
      padding: "10px 20px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      backgroundColor: isActive ? "#2563eb" : "#e5e7eb",
      color: isActive ? "#fff" : "#000",
      fontWeight: "bold",
    }),
    box: {
      width: "400px",
      backgroundColor: "#fff",
      padding: "2.5rem",
      borderRadius: "1rem",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      textAlign: "center",
    },
    title: {
      fontSize: "1.5rem",
      fontWeight: "bold",
    },
    text: {
      color: "#4b5563",
    },
    infoIcon: {
      marginLeft: "8px",
      textDecoration: "none",
      fontSize: "1.2rem",
      color: "#007bff",
    },
  };

  return (
          <div style={styles.container}>
          <select
          style={{
    position: "absolute",
    top: "20px",
    left: "20px",
    padding: "10px 14px",
    fontSize: "0.95rem",
    fontWeight: "600",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    color: "#1f2937",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    cursor: "pointer",
    outline: "none",
  }}
          defaultValue=""
          onChange={(e) => navigate(e.target.value)}
          onFocus={(e) => e.target.style.borderColor = "#2563eb"}
          onBlur={(e) => e.target.style.borderColor = "#d1d5db"}
          >
          <option value="" disabled>Select Month</option>
          <option value="/april25">April25</option>
          <option value="/may25">May25</option>
          <option value="/june25">June25</option>
          <option value="/july25">July25</option>
          <option value="/august25">August25</option>
          <option value="/september25">September25</option>
	  <option value="/october25">October25</option>
	  <option value="/novdec25">NovDec25</option>
          </select>
              {/* Added Heading*/}
              <h1 style={styles.heading}>Dola Gi: Hunt Your Limits</h1>
              {/* Tab Buttons */}
              <div style={styles.tabs}>
                <button
                  style={styles.tabButton(activeTab === "distance")}
                  onClick={() => setActiveTab("distance")}
                >
                  Distance
                </button>
                <button
                  style={styles.tabButton(activeTab === "strength")}
                  onClick={() => setActiveTab("strength")}
                >
                  Strength
                </button>
                <button
                  style={styles.tabButton(activeTab === "teams")}
                  onClick={() => setActiveTab("teams")}
                >
                  Teams
                </button>
              </div>

              {/* Leaderboard Box (Only one displayed at a time) */}
              <div style={styles.box}>
                {activeTab === "distance" && (
                  <>
                    <h2 style={styles.title}>Individual Distance Leaderboard</h2>
                    <p style={styles.text}>2 Km</p>
                    <SimpleTableDistance data={distanceData} />
                  </>
                )}
                {activeTab === "strength" && (
                  <>
                    <h2 style={styles.title}>Individual Strength Leaderboard</h2>
                    <p style={styles.text}>Reverse Lunges</p>
                    <SimpleTableStrength data={strengthData} />
                  </>
                )}
                {activeTab === "teams" && (
                  <>
                    <p style={styles.text}>Final result for January 2026</p>
                    <h2 style={styles.title}>
                      Teams Leaderboard
                    <SimpleTableTeams data={teamsData} />

                    </h2>
                        <p style={styles.text}>
                        For Team roster >>>
                      <Link to="/team-distribution" style={styles.infoIcon}>
                       Click here ℹ️
                      </Link>
                        </p>
                    <p style={styles.text}>
                     For Dolagi monthly challenge guidelines, rules and regulations >>>
                      <Link to="/rules_and_regulations" style={styles.infoIcon}>Click here
                        ℹ️
                      </Link>
                    </p>
                  </>
                )}
              </div>
            </div>
  );
};

export default January26;

